<template>
  <div
    v-loading="loading"
    class="main-content"
    element-loading-text="Loading..."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(170,170,170,0.5)"
  >
    <div class="section operations">
      <div class="triggers">
        <cargo-button-group-slider>
          <div :style="$selectByLang('width:60px;', 'width:60px;', 'width:60px;', 'width:100px;', 'width:100px;', 'width:100px;')" class="input-label">{{ $t('SeaExport.FlightNo') }}</div>
          <el-input v-model="filter.flightNo" style="width: 120px;" />
          <div class="input-label" :style="{marginLeft: '5px', width: $selectByLang('60px', '60px', '60px', '100px', '100px', '100px')}">{{ $t('SeaExport.AirlineCompany') }}</div>
          <cargo-advance-select
            :select-type="TYPE_NAMES.basic_data_Company"
            :method-params="{airCmp:true}"
            filterable
            :default-value="filter.carrierId||''"
            style="display: inline-block;width: 200px;"
            @parentCallBack="p=>{filter.carrierId=p.value||0}"
          />
          <div class="input-label" :style="{marginLeft: '5px', width: $selectByLang('60px', '60px', '60px', '100px', '100px', '100px')}">{{ $t('CargoMsg.Cargo_PortOfLoading') }}</div>
          <cargo-advance-select
            :select-type="TYPE_NAMES.basic_data_Airport"
            filterable
            :default-value="filter.loadingPortCode"
            style="display: inline-block;width: 120px;"
            @parentCallBack="p=>{filter.loadingPortCode=p.value}"
          />
          <div class="input-label" :style="{marginLeft: '5px', width: $selectByLang('60px', '60px', '60px', '100px', '100px', '100px')}">{{ $t('CargoMsg.Cargo_DestinationPort') }}</div>
          <cargo-advance-select
            :select-type="TYPE_NAMES.basic_data_Airport"
            filterable
            :default-value="filter.destinationPortCode"
            style="display: inline-block;width: 120px;"
            @parentCallBack="p=>{filter.destinationPortCode=p.value}"
          />
          <el-button type="primary" @click="queryHandler">{{ $t('SeaExport.Query') }}</el-button>
          <el-button
            v-permission="['button_AirTransitRoutingConfig_add']"
            type="primary"
            @click="addFlightHandler"
          >{{ $t('CargoMsg.Cargo_Add') }}</el-button>
          <el-button
            v-permission="['button_AirTransitRoutingConfig_edit']"
            :disabled="!selectedRow"
            type="primary"
            @click="editFlightHandler"
          >{{ $t('CargoMsg.Cargo_Edit') }}</el-button>
          <el-button
            v-permission="['button_AirTransitRoutingConfig_delete']"
            :disabled="!selectedRow"
            type="primary"
            @click="delHandler"
          >{{ $t('CargoMsg.Cargo_Delete') }}</el-button>
        </cargo-button-group-slider>
      </div>
    </div>
    <div style="flex-grow: 1;min-height: 350px;">
      <cargo-ag-grid
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="rowData"
        style="height: 100%;"
        @gridReady="params=>{gridApi=params.api}"
      />
    </div>
    <el-dialog
      v-el-drag-dialog
      :visible.sync="routingDialog.visible"
      :title="routingDialog.title"
      :width="$selectByLang('650px', '690px')"
      :close-on-click-modal="false"
      class="routing-form"
    >
      <el-form :label-width="$selectByLang('70px', '110px')" label-position="left">
        <el-form-item :label="$t('SeaExport.Flight')" class="lable-blue">
          <el-input :value="routingDialog.flightDescription.flightNo" :disabled="true" style="width: 120px;" />
          <el-button
            type="primary"
            style="margin-left: 5px;"
            @click="flightDescriptionSelectDialog.visible=true"
          >{{ $t('CargoMsg.Cargo_Select') }}</el-button>
        </el-form-item>
        <el-form-item :label="$t('SeaExport.AirlineCompany')" class="lable-blue">
          <cargo-advance-select
            :select-type="TYPE_NAMES.basic_data_Company"
            :method-params="{airCmp:true}"
            :show-custom-label-in-option="true"
            :custom-label="airCompanyLabel"
            :disabled="true"
            :default-value="routingDialog.flightDescription.carrierId||''"
            placeholder=" "
            style="display: inline-block;width: 300px;"
          />
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_PortOfLoading')" class="lable-blue">
          <cargo-advance-select
            :disabled="true"
            :select-type="TYPE_NAMES.basic_data_Airport"
            filterable
            :default-value="routingDialog.flightDescription.loadingPortCode"
            placeholder=" "
            style="width: 200px;"
          />
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_OneWayPort')" class="lable-blue">
          <cargo-advance-select
            :disabled="true"
            :select-type="TYPE_NAMES.basic_data_Airport"
            filterable
            :default-value="routingDialog.flightDescription.destinationPortCode"
            placeholder=" "
            style="width: 200px;"
          />
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_SecondPort')">
          <cargo-advance-select
            :select-type="TYPE_NAMES.basic_data_Airport"
            filterable
            :default-value="routingDialog.form.firstTransshipmentPortCode"
            placeholder=" "
            style="width: 200px;"
            @parentCallBack="p=>{routingDialog.form.firstTransshipmentPortCode=p.value}"
          />
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_ThirdPort')">
          <cargo-advance-select
            :select-type="TYPE_NAMES.basic_data_Airport"
            filterable
            :default-value="routingDialog.form.secondTransshipmentPortCode"
            placeholder=" "
            style="width: 200px;"
            @parentCallBack="p=>{routingDialog.form.secondTransshipmentPortCode=p.value}"
          />
        </el-form-item>
      </el-form>
      <el-tabs v-model="routingDialog.activeTabName" type="card" style="width: 100%;">
        <el-tab-pane key="flightSchedule" name="flightSchedule" :label="$t('CargoMsg.Cargo_FlightSchedule')" :lazy="true">
          <div class="section">
            <div>
              <div class="input-label" style="color: blue;">{{ $t('Pricing.BeginDate') }}</div>
              <el-date-picker
                v-model="routingDialog.form.beginValidDate"
                type="date"
                value-format="yyyy-MM-dd"
                :editable="false"
                :clearable="false"
                style="width: 120px;"
              />&nbsp;-
              <el-date-picker
                v-model="routingDialog.form.endValidDate"
                type="date"
                value-format="yyyy-MM-dd"
                :editable="false"
                :picker-options="{
                  disabledDate: time => {
                    return routingDialog.form.beginValidDate && time.getTime() < new Date(routingDialog.form.beginValidDate + ' 00:00:00').getTime()
                  }
                }"
                style="width: 120px;"
              />
            </div>
            <div style="display: flex;">
              <div class="input-label" :style="$selectByLang('', 'width: 100px;') + 'align-self: center;color: blue;'">{{ $t('AirExport.WeeklySchedule') }}</div>
              <div style="flex-grow: 1;display: flex;flex-direction: column;">
                <div v-for="(item,index) in routingDialog.flightScheduleItem" :key="index" style="display: flex;margin-top: 8px;">
                  <el-checkbox
                    v-model="item.checked"
                    :disabled="item.disabled"
                    style="height: 28px;line-height: 28px;"
                  >{{ $selectByLang($t('Partners.week'), '') }}{{ CNWeek[Number(item.itemName)] }}</el-checkbox>
                  <div v-show="item.checked" style="display: flex;margin-left: 10px;">
                    <span style="color: blue;align-self: center;">{{ $t('queryJob.takeoffTime') }}</span>
                    <el-input-number
                      v-model="item.departureTimeHour"
                      :disabled="true"
                      controls-position="right"
                      :min="0"
                      :max="23"
                      :precision="0"
                      style="width: 60px;margin-left: 5px;"
                    />
                    <span style="margin: 0 5px;align-self: center;">:</span>
                    <el-input-number
                      v-model="item.departureTimeMinutes"
                      :disabled="true"
                      controls-position="right"
                      :min="0"
                      :max="59"
                      :precision="0"
                      style="width: 60px;"
                    />
                    <span style="margin-left: 10px;align-self: center;">{{ $t('CargoMsg.Cargo_ArrivaledTime') }}</span>
                    <el-input-number
                      v-model="item.arrivalTimeHour"
                      controls-position="right"
                      :min="0"
                      :max="23"
                      :precision="0"
                      style="width: 60px;margin-left: 5px;"
                    />
                    <span style="margin: 0 5px;align-self: center;">:</span>
                    <el-input-number
                      v-model="item.arrivalTimeMinutes"
                      controls-position="right"
                      :min="0"
                      :max="59"
                      :precision="0"
                      style="width: 60px;"
                    />
                    <span style="margin-left: 10px;align-self: center;">{{ $t('Message.Page') }}</span>
                    <el-select v-model="item.flyingDays" style="width: 50px;margin: 0 5px;">
                      <el-option v-for="(item,index) in FLYING_DAYS" :key="index" :label="item" :value="item" />
                    </el-select>
                    <span style="align-self: center;">{{ $t('CargoMsg.Cargo_Days') }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane key="interiorPoints" name="interiorPoints" :label="$t('CargoMsg.Cargo_TransshipmentPort')" :lazy="true">
          <div class="section" style="height: 290px;">
            <cargo-ag-grid
              :grid-options="routingDialog.gridOptions"
              :column-defs="routingDialog.columnDefs"
              :row-data="routingDialog.airInteriorPoints"
              @gridReady="params=>{routingDialog.gridApi=params.api}"
            />
          </div>
        </el-tab-pane>
      </el-tabs>
      <span slot="footer" style="display: flex;">
        <div v-show="routingDialog.activeTabName==='interiorPoints'">
          <el-button type="primary" @click="addPointHandler">{{ $t('CargoMsg.Cargo_Add') }}</el-button>
          <el-button type="primary" @click="delPointHandler">{{ $t('CargoMsg.Cargo_Delete') }}</el-button>
        </div>
        <div style="flex-grow: 1;" />
        <el-button type="primary" @click="commitHandler">{{ $t('CargoMsg.Cargo_Confirm') }}</el-button>
        <el-button @click="routingDialog.visible=false">{{ $t('Message.Cancel') }}</el-button>
      </span>
    </el-dialog>
    <!-- 选择航班弹窗 -->
    <flight-description-select-dialog :visible.sync="flightDescriptionSelectDialog.visible" @callback="selectFlightDescription" />
  </div>
</template>

<script>
import CargoButtonGroupSlider from '@/components/Cargo/Common/CargoButtonGroupSlider'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import CargoAgGridAdvanceSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceSelectEditor'
import flightDescriptionSelectDialog from '@/views/cargo/v0/AirExport/components/airConfig/flightDescriptionSelectDialog'
import $store from '@/store'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import { getObjectByCache } from '@/utils/basicDataCache'
import { deepCopy } from '@/utils/commonUtil'
import { AirTransitRoutingDescription } from '@/class/model/booking/AirTransitRoutingDescription'
import { FlightDescription } from '@/class/model/booking/FlightDescription'
import { FlightScheduleItem } from '@/class/model/booking/FlightScheduleItem'
import { queryRoutings, saveRoutings, deleteRoutings } from '@/api/booking/airTransitRoutingDescription'
import lang from '@/lang'

const CNWeek = [lang.t('AirExport.Monday'), lang.t('AirExport.Tuesday'), lang.t('AirExport.Wednesday'), lang.t('AirExport.Thursday'), lang.t('AirExport.Friday'), lang.t('AirExport.Saturday'), lang.t('AirExport.Sunday')]

export default {
  name: 'AirTransitRoutingList',
  components: { CargoButtonGroupSlider, cargoAdvanceSelect, flightDescriptionSelectDialog },
  data() {
    return {
      loading: false,
      TYPE_NAMES,
      CNWeek,
      FLYING_DAYS: [0, 1, 2, 3, 4],
      ColumnUtils,
      filter: {
        branchId: 0,
        flightNo: '',
        carrierId: 0,
        loadingPortCode: '',
        destinationPortCode: ''
      },
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true, // 如果为true，则不能选择单元格。这意味着当您单击它们时，单元格不会获得键盘焦点。
        suppressRowClickSelection: true, // 如果为true，则单击行时不会发生行选择。当您想要专门选择复选框时使用。
        onRowDataChanged: event => {
          /* 清除单选行 */
          this.selectedNode = null
          event.api.clearFocusedCell()
        },
        onCellFocused: event => {
          const nodes = event.api.rowModel.rowsToDisplay
          this.selectedNode = nodes[event.rowIndex] || null
        },
        onCellDoubleClicked: event => {
          if (this.$checkPermission(['button_AirTransitRoutingConfig_edit'])) {
            this.editFlightHandler()
          }
        },
        onSortChanged: event => {
          // 重置单选行
          if (this.selectedNode) {
            const rowIndex = this.selectedNode.rowIndex
            this.selectedNode = null
            event.api.setFocusedCell(rowIndex, event.columnApi.getAllDisplayedColumns()[0])
          }
        },
        context: { componentParent: this }
      },
      columnDefs: [
        {
          headerName: this.$t('SeaExport.FlightNo'),
          width: 100,
          valueGetter: params => {
            const flightDescription = params.data.flightDescription
            return flightDescription ? flightDescription.flightNo : ''
          }
        }, {
          headerName: this.$t('SeaExport.AirlineCompany'),
          width: 100,
          valueGetter: params => {
            const flightDescription = params.data.flightDescription
            return flightDescription ? ColumnUtils.companyShortNameLabelFun(flightDescription.carrierId) : ''
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_PortOfLoading'),
          width: 100,
          valueGetter: params => {
            const flightDescription = params.data.flightDescription
            return flightDescription ? flightDescription.loadingPortCode : ''
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_OneWayPort'),
          width: 100,
          valueGetter: params => {
            const flightDescription = params.data.flightDescription
            return flightDescription ? flightDescription.destinationPortCode : ''
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_SecondPort'),
          field: 'firstTransshipmentPortCode',
          width: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_ThirdPort'),
          field: 'secondTransshipmentPortCode',
          width: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_Voyage'),
          field: 'flightScheduleItem',
          width: 180,
          valueGetter: params => {
            const items = params.data.flightScheduleItem
            if (items && items.length > 0) {
              let s = this.$selectByLang(this.$t('AirExport.Weekly'), '')
              const indexs = []
              for (const item of items) {
                indexs.push(Number(item.itemName))
              }
              indexs.sort()
              for (const index of indexs) {
                s += ' ' + CNWeek[index]
              }
              return s
            }
            return ''
          }
        }, {
          headerName: this.$t('Pricing.BeginDate'),
          width: 180,
          valueGetter: params => {
            const data = params.data
            let s = ColumnUtils.formateDateToString(data.beginValidDate, 'yyyy/MM/dd')
            if (data.endValidDate) {
              s += ' - ' + ColumnUtils.formateDateToString(data.endValidDate, 'yyyy/MM/dd')
            }
            return s
          }
        }
      ],
      rowData: [],
      selectedNode: null,
      gridApi: null,
      routingDialog: {
        visible: false,
        title: '',
        form: new AirTransitRoutingDescription().fillDefaultValue().getData(),
        flightDescription: new FlightDescription().fillDefaultValue().getData(),
        flightScheduleItem: [],
        airInteriorPoints: [],
        deletedAirInteriorPointKeys: [],
        gridOptions: {
          rowSelection: 'single',
          suppressCellSelection: true, // 如果为true，则不能选择单元格。这意味着当您单击它们时，单元格不会获得键盘焦点。
          suppressRowClickSelection: true, // 如果为true，则单击行时不会发生行选择。
          onRowDataChanged: event => {
            // 清除单选行
            event.api.clearFocusedCell()
          },
          frameworkComponents: { CargoAgGridAdvanceSelectEditor },
          context: { componentParent: this }
        },
        columnDefs: [
          {
            headerName: 'No',
            width: 60,
            sortable: false,
            suppressMenu: true,
            valueGetter: params => {
              return params.node.rowIndex + 1
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_TransshipmentPort'),
            field: 'interiorPointPortId',
            colId: 'interiorPointPortId',
            width: 300,
            sortable: false,
            suppressMenu: true,
            valueFormatter: params => {
              const airport = getObjectByCache(TYPE_NAMES.basic_data_Airport, 'code', params.value)
              return airport ? airport.englishName : ''
            },
            editable: true,
            cellEditor: 'CargoAgGridAdvanceSelectEditor',
            cellEditorParams: {
              selectProps: {
                selectType: TYPE_NAMES.basic_data_Airport,
                filterable: true,
                placeholder: ' ',
                clearable: false
              }
            }
          }
        ],
        gridApi: null,
        activeTabName: 'flightSchedule'
      },
      flightDescriptionSelectDialog: {
        visible: false
      }
    }
  },
  computed: {
    selectedRow() {
      return this.selectedNode ? this.selectedNode.data : null
    }
  },
  methods: {
    queryHandler() {
      this.filter.branchId = this.$store.getters.currentOfficeId
      this.loading = true
      queryRoutings(this.filter).then(res => {
        // 扩展字段信息（为了编辑时，可以被vue监听到值变化）
        for (const item of res.data) {
          for (const subItem of item.flightScheduleItem) {
            subItem.departureTimeHour = '' // 起飞时间小时部分
            subItem.departureTimeMinutes = '' // 起飞时间分钟部分
            subItem.arrivalTimeHour = '' // 到达时间小时部分
            subItem.arrivalTimeMinutes = '' // 到达时间分钟部分
            subItem.checked = false // 标记是否被选中
            subItem.disabled = false
          }
          for (const subItem of item.flightDescription.flightScheduleItem) {
            subItem.departureTimeHour = ''
            subItem.departureTimeMinutes = ''
            subItem.arrivalTimeHour = ''
            subItem.arrivalTimeMinutes = ''
            subItem.checked = false
            subItem.disabled = false
          }
        }
        this.rowData = res.data
      }).finally(() => {
        this.loading = false
      })
    },
    addFlightHandler() {
      this.routingDialog.title = this.$t('CargoMsg.Cargo_NewLine')
      this.routingDialog.form = new AirTransitRoutingDescription().fillDefaultValue().getData()
      this.routingDialog.form.branchId = this.$store.getters.currentOfficeId
      this.routingDialog.flightDescription = new FlightDescription().fillDefaultValue().getData()
      this.routingDialog.flightScheduleItem = []
      this.routingDialog.airInteriorPoints = []
      this.routingDialog.deletedAirInteriorPointKeys = []
      for (let i = 0; i < 7; ++i) {
        const e = new FlightScheduleItem().fillDefaultValue().getData()
        e.itemName = String(i)
        e.departureTimeHour = '' // 起飞时间小时部分
        e.departureTimeMinutes = '' // 起飞时间分钟部分
        e.arrivalTimeHour = '' // 到达时间小时部分
        e.arrivalTimeMinutes = '' // 到达时间分钟部分
        e.checked = false // 标记是否被选中
        e.disabled = true // 是否禁用
        this.routingDialog.flightScheduleItem.push(e)
      }
      this.routingDialog.activeTabName = 'flightSchedule'
      this.routingDialog.visible = true
    },
    editFlightHandler() {
      this.routingDialog.title = this.$t('CargoMsg.Cargo_EditLine')
      const form = deepCopy(this.selectedRow)
      this.routingDialog.form = form
      this.routingDialog.flightDescription = form.flightDescription
      this.routingDialog.flightScheduleItem = []
      this.routingDialog.airInteriorPoints = form.airInteriorPoints
      this.routingDialog.deletedAirInteriorPointKeys = []
      for (let i = 0; i < 7; ++i) {
        let e = form.flightScheduleItem.find(p => p.itemName === String(i))
        if (e) {
          e.checked = true
          e.disabled = false
        } else {
          e = form.flightDescription.flightScheduleItem.find(p => p.itemName === String(i))
          if (e) {
            e.uuid = ''
            e.flightDescriptionUuid = ''
            e.version = 1
            e.checked = false
            e.disabled = false
          }
        }
        if (e) {
          if (e.departureTime) {
            const hourMinutes = e.departureTime.split(':')
            e.departureTimeHour = Number(hourMinutes[0])
            e.departureTimeMinutes = Number(hourMinutes[1])
          } else {
            e.departureTimeHour = ''
            e.departureTimeMinutes = ''
          }
          if (e.arrivalTime) {
            const hourMinutes = e.arrivalTime.split(':')
            e.arrivalTimeHour = Number(hourMinutes[0])
            e.arrivalTimeMinutes = Number(hourMinutes[1])
          } else {
            e.arrivalTimeHour = ''
            e.arrivalTimeMinutes = ''
          }
        } else {
          e = new FlightScheduleItem().fillDefaultValue().getData()
          e.itemName = String(i)
          e.departureTimeHour = '' // 起飞时间小时部分
          e.departureTimeMinutes = '' // 起飞时间分钟部分
          e.arrivalTimeHour = '' // 到达时间小时部分
          e.arrivalTimeMinutes = '' // 到达时间分钟部分
          e.checked = false // 标记未被选中
          e.disabled = true
        }
        this.routingDialog.flightScheduleItem.push(e)
      }
      this.routingDialog.activeTabName = 'flightSchedule'
      this.routingDialog.visible = true
      console.log(this.routingDialog)
    },
    selectFlightDescription(data) {
      this.routingDialog.flightDescription = data
      this.routingDialog.form.flightDescriptionUuid = data.uuid
      for (let i = 0; i < 7; ++i) {
        const e = this.routingDialog.flightScheduleItem[i]
        const source = data.flightScheduleItem.find(p => p.itemName === String(i))
        if (source) {
          Object.assign(e, source)
          e.uuid = ''
          e.flightDescriptionUuid = ''
          if (e.departureTime) {
            const hourMinutes = e.departureTime.split(':')
            e.departureTimeHour = Number(hourMinutes[0])
            e.departureTimeMinutes = Number(hourMinutes[1])
          } else {
            e.departureTimeHour = ''
            e.departureTimeMinutes = ''
          }
          if (e.arrivalTime) {
            const hourMinutes = e.arrivalTime.split(':')
            e.arrivalTimeHour = Number(hourMinutes[0])
            e.arrivalTimeMinutes = Number(hourMinutes[1])
          } else {
            e.arrivalTimeHour = ''
            e.arrivalTimeMinutes = ''
          }
          e.checked = true
          e.disabled = false
        } else {
          e.checked = false
          e.disabled = true
        }
      }
    },
    airCompanyLabel(item) {
      if (item) {
        const filedName = $store.getters.language === 'zh' ? 'chineseName' : 'englishName'
        return '[' + item.shortName + ']' + item[filedName]
      }
      return ''
    },
    addPointHandler() {
      const dialog = this.routingDialog
      dialog.airInteriorPoints.push({ interiorPointPortId: '' })
      setTimeout(() => {
        dialog.gridApi.setFocusedCell(dialog.airInteriorPoints.length - 1, 'interiorPointPortId')
        dialog.gridApi.startEditingCell({ rowIndex: dialog.airInteriorPoints.length - 1, colKey: 'interiorPointPortId' })
      }, 100)
    },
    delPointHandler() {
      const cell = this.routingDialog.gridApi.getFocusedCell()
      const row = cell ? this.routingDialog.airInteriorPoints[cell.rowIndex] : null
      if (row) {
        if (row.uuid) {
          this.routingDialog.deletedAirInteriorPointKeys.push(row.uuid)
        }
        const index = this.routingDialog.airInteriorPoints.findIndex(p => p === row)
        this.routingDialog.airInteriorPoints.splice(index, 1)
      }
    },
    commitHandler() {
      const form = this.routingDialog.form
      if (!this.routingDialog.flightDescription.uuid) {
        this.$message.warning(this.$t('AirExport.PleaseSelectAFlight'))
        return
      }
      if (!form.beginValidDate) {
        this.$message.warning(this.$t('AirExport.PleaseEffectiveDateStartTime'))
        return
      }
      let count = 0
      for (const item of this.routingDialog.flightScheduleItem) {
        if (!item.checked) {
          continue
        }
        count += 1
      }
      if (count === 0) {
        this.$message.warning(this.$t('AirExport.PleaseSelectTheSchedule'))
        return
      }
      form.flightScheduleItem = []
      const deletedFlightShceduleKeys = []
      for (const item of this.routingDialog.flightScheduleItem) {
        if (!item.checked) {
          if (item.uuid) {
            deletedFlightShceduleKeys.push(item.uuid)
          }
          continue
        }
        if (!isNaN(item.arrivalTimeHour) && !isNaN(item.arrivalTimeMinutes)) {
          item.arrivalTime = (item.arrivalTimeHour < 10 ? '0' : '') + item.arrivalTimeHour + ':' + (item.arrivalTimeMinutes < 10 ? '0' : '') + item.arrivalTimeMinutes
        }
        form.flightScheduleItem.push(item)
      }
      form.airInteriorPoints = this.routingDialog.airInteriorPoints
      for (const item of form.airInteriorPoints) {
        if (!item.interiorPointPortId) {
          this.$message.warning(this.$t('AirExport.PleaseEnterTheTransshipmentPort'))
          return
        }
      }
      this.loading = true
      saveRoutings(form, {
        deletedFlightScheduleItemKeys: deletedFlightShceduleKeys.join(','),
        deletedAirInteriorPointsKeys: this.routingDialog.deletedAirInteriorPointKeys.join(',')
      }).then(res => {
        this.queryHandler()
        this.routingDialog.visible = false
        this.$message.success(this.$t('Message.SaveSuccessfully'))
      }).catch(() => {
        this.loading = false
      })
    },
    delHandler() {
      this.$confirm(this.$t('AirExport.AreWantToDeleteRoute'), this.$t('Message.Confirm'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        this.loading = true
        deleteRoutings({ uuid: this.selectedRow.uuid }).then(res => {
          this.queryHandler()
        }).catch(() => {
          this.loading = false
        })
      }).catch()
    }
  }
}
</script>

<style scoped lang="scss">
.input-label {
  display: inline-block;
  width: 60px;
  color: #666666;
}
.routing-form .lable-blue ::v-deep {
  .el-form-item__label {
    color: blue !important;
  }
}
</style>
